'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrapToggle = require('./react-bootstrap-toggle');

var _reactBootstrapToggle2 = _interopRequireDefault(_reactBootstrapToggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Exports the component with bootstrap 2 style names
 */
var ReactBootstrap2Toggle = function (_Toggle) {
  _inherits(ReactBootstrap2Toggle, _Toggle);

  function ReactBootstrap2Toggle() {
    _classCallCheck(this, ReactBootstrap2Toggle);

    return _possibleConstructorReturn(this, (ReactBootstrap2Toggle.__proto__ || Object.getPrototypeOf(ReactBootstrap2Toggle)).apply(this, arguments));
  }

  _createClass(ReactBootstrap2Toggle, [{
    key: 'getSizeClass',
    value: function getSizeClass() {
      if (this.props.size === 'large') return 'btn-large';
      if (this.props.size === 'small') return 'btn-small';
      if (this.props.size === 'mini') return 'btn-mini';
      return '';
    }
  }]);

  return ReactBootstrap2Toggle;
}(_reactBootstrapToggle2.default);

exports.default = ReactBootstrap2Toggle;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-bootstrap-toggle/dist/react-bootstrap2-toggle.js
 ** module id = 789
 ** module chunks = 0
 **/